import { BACKEND_URL } from "../env";
import { Profile } from "../types/profile";

export async function fetchUserProfile(): Promise<Profile | undefined> {
  try {
    const response = await fetch(`${BACKEND_URL}/keycloak/profile`, {
      credentials: "include",
    });

    if (response.status >= 400) {
      return undefined;
    }

    const profile = (await response.json()) as Profile;
    return profile;
  } catch {
    return undefined;
  }
}
